<template>
  <li class="mt-[4px] mb-[4px] w-full px-[10px] py-[6px] border border-[#CFCFCF] rounded-lg bg-white shadow-sm hover:shadow-md transition-shadow text-base">
    <h2 class="uppercase font-jost-medium text-blue-dark text-base">{{ metadata.chainName }} Metadata</h2>
    <div class="flex items-center justify-between">
      <!-- Middle: Metadata Details -->
      <div class="flex-1 flex items-center gap-[50px] min-w-0">
        <!-- Metadata - Truncated -->
        <div class="flex items-center min-w-0 flex-2 w-full overflow-hidden">
          <span class="text-[#6B7280] font-medium mr-1 text-base shrink-0">Metadata:</span>
          <router-link
            v-if="metadata.meta && metadata.meta.value"
            class="text-[#5B6BD5] font-jost-regular text-base hover:underline flex-1 min-w-0 max-w-full block truncate"
            :title="metadata.meta.value"
            :to="metadataLinkTo"
          >
            {{ metadata.value }}
          </router-link>
          <span v-else class="text-[#374151] font-jost-regular text-base flex-1 min-w-0 max-w-full block truncate" :title="metadata.value">
            {{ metadata.value }}
          </span>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import {
  formatDateTime,
  truncateAddress
} from '@/helpers/common';

export default {
  name: 'MetadataCard',
  props: {
    metadata: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  methods: {
    formatDateTime(timestamp) {
      return formatDateTime(timestamp);
    },
    truncateAddress(address) {
      return truncateAddress(address);
    },
  }
  ,
  computed: {
    metadataLinkTo() {
      const chain = this.metadata.chainNumber || this.$route.params.chainNumber || this.$route.params.chain;
      if (this.metadata?.meta?.type === 'nft') {
        return {
          name: 'nft',
          params: {
            chainNumber: chain,
            nftId: this.metadata.meta.value,
          },
        };
      }

      return {
        name: 'transaction',
        params: {
          chainNumber: chain,
          txRefhash: this.metadata.meta.value,
        },
      };
    },
  },
}
</script>

<style scoped>
.metadata-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
}
</style>
